<template>
  <div>
    <div class="container" style="display:none;">
      <div class="pd">
        <div class="heading grid ">
          <div class="heading-text">
            <h1>
              you can earn as high <br />
              as 60k/month!
            </h1>
            <h5>
              Join the CSS Course designed for companies that are hiring
              Software Engineers. <br />
              Kickstarting your Engineering Career in a few clicks! <br />
              For more information about us, please contact us
              <span>
                upskill@upskillbangladesh.com
              </span>
            </h5>
          </div>
        </div>
        <div class="form-inner " id="chaldal">
          <div class="about-you pd-inner">
            <h2>
              About You
            </h2>
            <p class="subtitle">
              Please tell us a little bit about yourself.
            </p>

            <h3 class="top-gap-1">
              Your Name*
            </h3>
            <input
              type="text"
              required
              v-model="model.name"
              placeholder="State your full name"
              class="text-placeholder"
            />

            <h3>
              Your Email Address*
            </h3>
            <input
              type="email"
              required
              v-model="model.email"
              placeholder="Ex: johndoe@gmail.com"
              class="text-placeholder"
            />

            <h3>
              Your Phone Number*
            </h3>
            <input
              type="text"
              required
              v-model="model.phone"
              placeholder="Ex: 017XXXXXXX"
              class="text-placeholder"
            />
             <h3>
              Your Phone Number*
            </h3>
            <input
              type="text"
              required
              v-model="model.phone"
              placeholder="Ex: 017XXXXXXX"
              class="text-placeholder"
            />
          </div>

          <div class="personality ">
            <!-- <div class="pd-inner">
              <h3>
                What is your area of interest?
              </h3>
              <div class="flex-1 bg-white gap-2">
                <div class="radio ">
                  <div class="inpite">
                    <input
                      type="radio"
                      value="bill"
                      v-model="model.per_why"
                      name="why"
                    />
                  </div>
                  <div class="labeling">
                    <label for="scales">Software Engineer</label>
                  </div>
                </div>
                <div class="radio">
                  <div class="inpite">
                    <input
                      type="radio"
                      value="impact"
                      v-model="model.per_why"
                      name="why"
                    />
                  </div>

                  <div class="labeling">
                    <label for="horns">Frontend Web Developer</label>
                  </div>
                </div>
                <div class="radio">
                  <div class="inpite">
                    <input
                      type="radio"
                      value="hobby"
                      v-model="model.per_why"
                      name="why"
                    />
                  </div>
                  <div class="inpite">
                    <label for="scales">Backend Web Developer</label>
                  </div>
                </div>
                <div class="radio">
                  <div class="inpite">
                    <input
                      type="radio"
                      value="rich"
                      v-model="model.per_why"
                      name="why"
                    />
                  </div>
                  <div class="labeling">
                    <label for="scales">DevOps Engineer</label>
                  </div>
                </div>
                <div class="radio">
                  <div class="inpite">
                    <input
                      type="radio"
                      value="flexibility"
                      v-model="model.per_why"
                      name="horns"
                    />
                  </div>
                  <div class="labeling">
                    <label for="scales">Database Engineer</label>
                  </div>
                </div>
                <div class="radio">
                  <div class="inpite">
                    <input
                      type="radio"
                      value="flexibility"
                      v-model="model.per_why"
                      name="horns"
                    />
                  </div>
                  <div class="labeling">
                    <label for="scales">UI/UX Designer</label>
                  </div>
                </div>
              </div>
            </div> -->

            <div class="pd-inner">
              <div class="upload cv flex-1">
                <uploader @uploaded="uploaded"></uploader>
                <strong v-if="isFileUploaded"
                  >File received at {{ fileDate }}</strong
                >
                <div class="radio-1">
                  <label>
                    <input
                      type="checkbox"
                      value="agree"
                      v-model="model.agree"
                      required
                    />
                    <span aria-label="Normal Checkbox" class="terms">
                      I agree to the
                      <span
                        ><a
                          href="https://upskill.com.bd/isa/terms"
                          target="_blank"
                        >
                          terms and conditions of ISA Program
                        </a>
                      </span>
                    </span>
                  </label>
                </div>
                <div class="radio-1 radio-3 box ">
                  <label class="seco">
                    <input
                      type="checkbox"
                      value="agree"
                      v-model="model.wish"
                      checked
                    />
                    <span class="check">
                      I wish to be contracted for further job
                      opportunities</span
                    >
                  </label>
                </div>
              </div>
              <div>
                <button class="submit-btn" disabled>
                  Submit Application
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Uploader from "@/components/Uploader";
import axios from "axios";
import moment from "moment";
export default {
  components: { Uploader },
  data() {
    return {
      model: { wish: false },
      isFileUploaded: false,
      fileDate: "",
    };
  },
  methods: {
    uploaded(e) {
      // console.log(e)
      this.model.cv = e.link;
      this.isFileUploaded = true;
      this.fileDate = moment().format("LT");
    },
    Submit() {
      if (!this.model.agree) {
        this.ErrorAlert(
          "You must agree to the terms and condition before submitting the application!"
        );
      } else {
        // const LINK = "http://localhost:8080"
        const LINK = "https://service6.upskill.com.bd";
        axios
          .post(`${LINK}/api/submit/chaldal`, this.model)
          .then(() => {
            this.SuccessAlert(
              "Form submitted successfully! You will be contacted soon."
            );
            this.model = {};
          })
          .catch(() => {
            // console.log(err)
            this.ErrorAlert(
              "Please fill up all the fields! Please contact us if you any queries."
            );
          });
      }
    },
  },
};
</script>

<style scoped>
input[type="radio"] {
  min-width: 30px;
}

input[type="checkbox"] {
  position: absolute;
  opacity: 0;
  z-index: -1;
}

input[type="checkbox"] + span {
  font: 16pt sans-serif;
  color: #000;
}

input[type="checkbox"] + span:before {
  font: 16pt FontAwesome;
  content: "\00f096";
  display: inline-block;
  width: 16pt;
  padding: 2px 0 0 3px;
  margin-right: 0.5em;
}

input[type="checkbox"]:checked + span:before {
  content: "\00f046";
}

input[type="checkbox"]:focus + span:before {
  outline: 1px solid #aaa;
}

input[type="checkbox"]:disabled + span {
  color: #999;
}

input[type="checkbox"]:not(:disabled) + span:hover:before {
  text-shadow: 0 1px 2px #77f;
}
.radio-1 label {
  margin-top: 50px;
  margin-left: 0;
}
.radio-3 label {
  margin-top: 0px;
  margin-left: 0;
}

label {
  cursor: pointer;
  margin-left: 21px;

  margin-bottom: 0;
  font-family: "Poppins";
  font-size: 18px;
  font-weight: 400;
  letter-spacing: 0px;

  color: #304f64;
}
input::-webkit-input-placeholder {
  /* WebKit browsers */
  line-height: 1.5em;
}
input:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  line-height: 1.5em;
}
input::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  line-height: 1.5em;
}
input:-ms-input-placeholder {
  /* Internet Explorer 10+ */
  line-height: 1.5em;
}
input {
  padding-top: 10px;
  line-height: 0;
  text-indent: 25px;
}
.bg-white-1 {
  background-color: white;
  padding: 25px;
}
.bg-white {
  background-color: white;
  padding: 20px;
}

.cv h3 {
  margin-top: 64px;
  margin-bottom: 50px;
}
.radio-1 h5 {
  font-family: "Poppins";
  font-size: 16px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 24px;
  color: #304f64;
  padding-left: 18px;
}
.radio-1 {
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  margin-right: 15px;
}
.radio {
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  margin-right: 10px;
}
.text-placeholder {
  width: 100%;
  min-height: 50px;
}
input::placeholder {
  width: 100%;
  color: #304f64;
  font-family: "Poppins";
  font-size: 18px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 24px;
}
.submit-btn {
  margin-top: 50px;
  top: 7845px;
  left: 460px;
  width: 400px;
  height: 60px;
  background-color: #ffc600;
  text-align: center;
  font: normal normal bold 18px/24px Spartan;
  opacity: 1;
}

.flex-1 {
  display: flex;
  flex-direction: column;
}

.form-inner {
  padding: 0 0px;
  max-width: 1000px;
  margin: 0 auto;
}

.form-inner .head {
  margin-top: 100px;
  margin-bottom: 50px;
  text-transform: uppercase;
  font-family: "Spartan";
  font-size: 18px;
  font-weight: 700;
  letter-spacing: 7.2px;
  line-height: 24px;
  color: black;
  border-bottom: 1px solid #304f64;
}

.form-inner .head-p {
  font-family: "Poppins";
  font-size: 16px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 24px;
  color: #304f64;
}

.form-inner .head-p span {
  font-family: "Poppins";
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0px;
  line-height: 24px;
  color: #304f64;
}
h5 {
  font-family: "Poppins";
  font-size: 18px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 24px;
  color: #304f64;
}
.form-inner h3 {
  text-transform: capitalize;
  font-family: "Spartan";
  font-size: 18px;
  font-weight: 700;
  letter-spacing: 0px;
  line-height: 24px;
  color: #304f64;
  margin-top: 30px;
}

.form-inner input {
  background: #ffffff;
}

.about-you h2 {
  margin-top: 50px;
  text-transform: uppercase;
  font-family: "Spartan";
  font-size: 24px;
  font-weight: 700;
  letter-spacing: 0px;
  line-height: 24px;
  color: #072ac8;
}

.about-you .subtitle {
  font-family: "Poppins";
  font-size: 16px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 24px;
  color: #304f64;
  border-bottom: 5px solid #072ac8;
  padding-bottom: 10px;
}

.education h2 {
  margin-top: 50px;
  text-transform: uppercase;
  font-family: "Spartan";
  font-size: 24px;
  font-weight: 700;
  letter-spacing: 0px;
  line-height: 24px;
  color: #072ac8;
}

.education .subtitle {
  font-family: "Poppins";
  font-size: 16px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 24px;
  color: #304f64;
  border-bottom: 5px solid #072ac8;
  padding-bottom: 10px;
}

.experience h2 {
  margin-top: 50px;
  text-transform: uppercase;
  font-family: "Spartan";
  font-size: 24px;
  font-weight: 700;
  letter-spacing: 0px;
  line-height: 24px;
  color: #072ac8;
}

.experience .subtitle {
  font-family: "Poppins";
  font-size: 16px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 24px;
  color: #304f64;
  border-bottom: 5px solid #072ac8;
  padding-bottom: 15px;
}

.personality h2 {
  margin-top: 50px;
  text-transform: uppercase;
  font-family: "Spartan";
  font-size: 24px;
  font-weight: 700;
  letter-spacing: 0px;
  line-height: 24px;
  color: #072ac8;
}

.personality .subtitle {
  font-family: "Open Sans";
  font-size: 16px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 24px;
  color: #304f64;
  border-bottom: 5px solid #072ac8;
  padding-bottom: 10px;
}
.grid {
  padding: 60px 0 60px 150px;
}

.heading-text h1 {
  padding-top: 0px;
  text-transform: uppercase;
  font-family: "Open Sans";
  font-size: 60px;
  font-weight: 800;
  letter-spacing: -3px;
  line-height: 70px;
  color: #072ac8;
}
.heading-text h5 {
  font-family: "Open Sans";
  font-size: 16px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 24px;
  color: #304f64;
}
.heading-text h5 span {
  font-family: "Open Sans";
  font-size: 20px;
  font-weight: 700;
  letter-spacing: 0px;
  line-height: 24px;
  color: #304f64;
}

.heading-text h3 {
  padding-bottom: 40px;
}

.heading {
  background: #ffc600;
  border-radius: 10px 10px 0 0;
}

.heading img {
  max-width: 312px;
  max-height: 135px;
}

.pd {
  background: #181c2d0c;
  padding: 0px 0px;
  max-width: 1300px;
  margin: 100px auto;
  padding-bottom: 100px;
}
.terms span {
  color: #072ac8;
}
.inpite {
  margin-top: 5px;
}
@media only screen and (min-width: 601px) and (max-width: 1100px) {
  .container {
    padding-left: 0;
    padding-right: 0;
  }
  .pd {
    padding: 0px 25px;
    margin: 100px auto;
    padding-bottom: 100px;
  }
}

@media only screen and (max-width: 600px) {
  .radio {
    display: -webkit-box;
  }
  .inpite {
    height: 100%;
    vertical-align: middle;
  }

  label {
    cursor: pointer;
  }
  .gap-1 .labeling {
    margin-top: 25px;
  }
  .gap-2 .labeling {
    padding-bottom: 10px;
    padding-top: 10px;
  }
  .col-md-1 {
    padding: 0;
  }
  h5 {
    font-family: "Poppins";
    font-size: 14px;
    font-weight: 400;
    letter-spacing: 0px;
    line-height: 10px;
    color: #304f64;
  }
  .form-inner {
    padding: 0 5px !important;
  }
  .form-inner .head {
    margin-top: 50px;
  }
  .row {
    flex-wrap: nowrap;
    border-bottom: 1px solid #304f64;
  }
  .bg-white-1 {
    padding: 0;
  }
  .submit-btn {
    top: 7845px;
    left: 460px;
    margin-top: 25px;
    max-width: 300px;
    height: 60px;
    background-color: #ffc600;
    text-align: center;
    font: normal normal bold 18px/24px Spartan;
    opacity: 1;
  }
  .grid {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    padding: 25px;
  }

  .container {
    padding-left: 0;
    padding-right: 0;
  }

  .form-inner {
    padding: 0 20px;
  }

  .heading-text h1 {
    padding-top: 0px;
    text-transform: uppercase;
    font-family: "Spartan";
    font-size: 30px;
    font-weight: 800;
    letter-spacing: -1px;
    line-height: 40px;
    color: #072ac8;
  }
  .heading-text h5 {
    font-family: "poppins";
    font-size: 16px;
    font-weight: 400;
    letter-spacing: 0px;
    line-height: 24px;
    color: #304f64;
  }
  .heading-text h5 span {
    font-family: "poppins";
    font-size: 20px;
    font-weight: 700;
    letter-spacing: 0px;
    line-height: 24px;
    color: #304f64;
  }

  .heading-text h3 {
    padding-bottom: 20px;
  }

  .heading img {
    min-width: 100%;
  }
  .pd {
    padding: 0px 0px;
    margin: 0px auto;
    padding-bottom: 100px;
  }
  .pd-inner {
    padding: 0 10px;
  }
}
</style>
